import { BASE_HANDLER_URL } from "..";
import { DEFAULT_GRID_INFO_CLIENT_TICKET } from "../../Components/ClientDetail/ClientTicket/KendoClientDetailTickets";

export const loadClientTicketGridData = async (status, clientId, gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ?? DEFAULT_GRID_INFO_CLIENT_TICKET.currentPageNumber;
  const currentSize =
    gridState.pageSize ?? DEFAULT_GRID_INFO_CLIENT_TICKET.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_CLIENT_TICKET.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_CLIENT_TICKET.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      TXTALLKEYWORDS: "",
      Reporter: "",
      TXTALLSTATUS: status,
      TXTALLASSIGNEE: "",
      TXTPRACTICENAME: "",
      ticketCategory: "",
      TXTALLPRIORITY: "",
      teamCategory: "",
      followDays: "",
      priorityClients: "",
      StatusDays: "",
      txtAllInternalAssignee: "",
      suspended: "",
      CustAccNum: clientId,
      client: "",
      FromDate: "",
      ToDate: "",
      TargetDate: "",
      overDue: "",
      ddlDteam: "",
      userType: sessionStorage.type,
      CP: sessionStorage.CP,
      APPUSER: sessionStorage.USER,
      Reseller: sessionStorage.Reseller,
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_CLIENT_TICKET.className
    }&action=${DEFAULT_GRID_INFO_CLIENT_TICKET.action}&${
      queryParams ? `${queryParams}` : ""
    }`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    // hideLoader();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    } if (
      response?.status === false &&
      response?.Message ===
        "Collection was modified; enumeration operation may not execute."
    ) {
      // LoadData();
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};
